// extracted by mini-css-extract-plugin
module.exports = {"title":"gallery_title__2_xuo","container":"gallery_container__1gY3y","images":"gallery_images__1Svqi","credit":"gallery_credit__3Nzs-"};